import dayjs from 'dayjs';

const types = {
  deposit: 0,
  withdrawal: 1,
}

const convertPlayersDeposits = formData => {
  const { id, username, from, to, itemsOnPage, page, type } = formData;

  const count = itemsOnPage.find(i => i.active)?.value ?? 10;

  const isTypeAll = type.includes('all') || (type.includes('deposit') && type.includes('withdrawal'));
  const finalType = isTypeAll ? undefined : types[type];

  return {
    id: id || undefined,
    date_from: dayjs(from).format('YYYY-MM-DD') || undefined,
    date_to: dayjs(to).format('YYYY-MM-DD') || undefined,
    username: username || undefined,
    type: finalType,
    count,
    page,
  };
};

export default convertPlayersDeposits;
